// A new Idempotency-Key value. The backoffice create requests get one from the axios interceptor
// (axiosConfig.js); each lesson and role-play turn gets one when the learner acts, and every retry
// of that turn sends it again.
export function generateIdempotencyKey() {
  try {
    // Prefer Web Crypto API if available
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
  } catch (_) {}
  // Fallback: pseudo-UUID v4-ish
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}
